import NewContactPage from "@/components/screens/contact/new";

export default function NewContact() {
  return <NewContactPage />;
}
